import { useState, useEffect } from "react";

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, name: "" });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      let name = "";

      if (width >= 2560) {
        
        name = "ultra-wide";
      } else if (width >= 1920) {
        name = "large-monitor";
      } else if (width >= 1600) {
        name = "medium-monitor";
      } else if (width >= 1440) {
        name = "full-hd";
      } else if (width >= 1280) {
        name = "laptop";
      } else if (width >= 1024) {
        name = "small-laptop";
      } else if (width >= 768) {
        name = "tablet";
      } else if (width >= 600) {
        name = "large-phone";
      } else if (width >= 480) {
        name = "medium-phone";
      } else {
        name = "small-phone";
      }

      setWindowSize({ width, name });
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
};

export default useWindowSize;
